<template>
  <div class="reveiw">
    <div class="title">
      {{ reviewMessage.cardEvaluationInvitation.satisfactionRatingGuide }}
    </div>
    <div class="list">
      <div
        v-for="(m, n) in reviewMessage.cardEvaluationInvitation
          .levelEvaluationExtList"
        :key="n"
        class="item"
        @click="onSelectRate(m.level)"
      >
        <img
          class="img-icon"
          :src="
            evaluationLevel !== m.level
              ? list[n].disabledSrc
              : list[n].activeSrc
          "
          :alt="m.evaluationTag"
        />
        <span
          class="item_title"
          :class="evaluationLevel === m.level ? 'font-bold' : ''"
          >{{ m.evaluationTag }}</span
        >
      </div>
    </div>
    <div class="title">
      {{ reviewMessage.cardEvaluationInvitation.evaluationGuideContent }}
    </div>
    <div class="tags">
      <div
        v-for="(m, n) in reviewMessage.cardEvaluationInvitation.evaluationTags"
        :key="n"
        class="tag"
        @click="onSelectTag(n)"
      >
        <div
          class="bg"
          :style="
            evaluationSelected === n && {
              backgroundColor: m.textColor,
            }
          "
        ></div>
        <div class="img_box">
          <img
            class="img_icon"
            :src="evaluationSelected === n ? m.iconSel : m.iconUnsel"
          />
        </div>
        <div
          class="tag_title"
          :style="evaluationSelected === n && { color: m.textColor }"
        >
          {{ m.evaluationTag }}
        </div>
      </div>
    </div>
    <Button
      v-if="!hideButton"
      type="primary"
      :disabled="evaluationLevel === 0 || evaluationSelected === -1"
      round
      block
      class="btn"
      @click="doSubmit"
      >{{ reviewMessage.cardEvaluationInvitation.sendButtonText }}</Button
    >
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { showFailToast, Button } from "vant";
import { submitReview } from "@/api/msg.js";
import very_dissatisfied_disabled from "@/assets/images/im/very_dissatisfied_disabled.png";
import very_dissatisfied from "@/assets/images/im/very_dissatisfied.png";
import dissatisfied from "@/assets/images/im/dissatisfied.png";
import dissatisfied_disabled from "@/assets/images/im/dissatisfied_disabled.png";
import generally from "@/assets/images/im/generally.png";
import generally_disabled from "@/assets/images/im/generally2_disabled.png";
import very_satisfied from "@/assets/images/im/very_satisfied.png";
import very_satisfied_disabled from "@/assets/images/im/very_satisfied2_disabled.png";
import satisfied from "@/assets/images/im/satisfied.png";
import satisfied_disabled from "@/assets/images/im/satisfied_disabled.png";

const props = defineProps({
  reviewMessage: {
    default: () => ({}),
    type: Object,
  },
});

const evaluationLevel = ref(0);
const evaluationSelected = ref(-1);
const hideButton = ref(false);

const list = ref([
  {
    level: 1,
    activeSrc: very_dissatisfied,
    disabledSrc: very_dissatisfied_disabled,
  },
  { level: 2, activeSrc: dissatisfied, disabledSrc: dissatisfied_disabled },
  { level: 3, activeSrc: generally, disabledSrc: generally_disabled },
  { level: 4, activeSrc: satisfied, disabledSrc: satisfied_disabled },
  { level: 5, activeSrc: very_satisfied, disabledSrc: very_satisfied_disabled },
]);

const doSubmit = async () => {
  try {
    const [tag] =
      props.reviewMessage.cardEvaluationInvitation.levelEvaluationExtList.filter(
        (tagItem) => tagItem.level === evaluationLevel.value,
      );
    const params = {
      messageId: props?.reviewMessage?._id,
      evaluationLevel: tag.level,
      evaluationTag:
        props.reviewMessage.cardEvaluationInvitation.evaluationTags[
          evaluationSelected.value
        ].evaluationTag,
    };
    submitReview(params).then((res: any) => {
      if (res.data) {
        hideButton.value = true;
      } else {
        showFailToast(res.rtn_msg);
      }
    });
  } catch (e: any) {
    showFailToast(e.message);
  }
};

const onSelectRate = async (level) => {
  evaluationLevel.value = level;
};

const onSelectTag = (e) => {
  evaluationSelected.value = e;
};
</script>

<style scoped lang="scss">
.reveiw {
  padding: 10px;
  color: #333;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
  }
  .list {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    .item {
      flex: 1;
      display: inline-flex;
      flex-flow: column nowrap;
      align-items: center;
      text-align: center;
      max-width: 20%;
      margin: 0 6px;
      line-height: 12px;
    }
    .item_title {
      margin-top: 8px;
      display: inline-flex;
      height: 24px;
      align-items: center;
      font-size: 10px;
    }
    .img-icon {
      width: 32px;
    }
  }
  .tags {
    display: flex;
    padding-bottom: 10px;
    overflow-y: auto;
    .tag {
      position: relative;
      display: flex;
      align-items: center;
      margin-right: 20px;
      padding: 5px 28px;
      color: #bdbdbd;
      border-radius: 14px;
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #bdbdbd;
        opacity: 0.3;
        border-radius: 14px;
      }

      .img_box {
        width: 18px;
        height: 18px;
        .img_icon {
          width: 18px;
          height: 18px;
        }
      }

      .tag_title {
        margin-left: 4px;
        font-size: 13px;
      }
    }
  }
  .btn {
    margin-top: 15px;
    height: 38px;
  }
}
</style>
